import { reactive } from 'vue'

const state = reactive({
  visible: false,
  title: '',
  message: '',
  confirmText: 'Удалить',
  cancelText: 'Отмена',
  variant: 'danger',
  resolver: null
})

function ask(options = {}) {
  state.visible = true
  state.title = options.title || 'Подтвердите действие'
  state.message = options.message || 'Это действие нельзя отменить.'
  state.confirmText = options.confirmText || 'Удалить'
  state.cancelText = options.cancelText || 'Отмена'
  state.variant = options.variant || 'danger'

  return new Promise(resolve => {
    state.resolver = resolve
  })
}

function close(result) {
  state.visible = false
  if (state.resolver) state.resolver(result)
  state.resolver = null
}

export default {
  install(app) {
    app.config.globalProperties.$confirm = ask
    app.provide('confirmState', state)
    app.provide('confirmClose', close)
  }
}
